import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveLoadedInstance = (state, instance) =>
  state.some((item) => item.distributionListId === instance.distributionListId);

export const distributionListSlice = createSlice({
  name: 'distributionLists',
  initialState: initialState,
  reducers: {
    clearDistributionLists: () => {
      return initialState;
    },

    addDistributionList: (state, action) => {
      const instance = action.payload;
      return haveLoadedInstance(state, instance) ? state : state.concat(instance);
    },

    updateDistributionList: (state, action) => {
      const instance = action.payload;
      const prunedList = state.filter((dl) => dl.distributionListId !== instance.distributionListId);
      return [...prunedList, instance];
    },

    addDistributionLists: (state, action) => {
      let listSoFar = state;
      action.payload.forEach((instance) => {
        if (!haveLoadedInstance(listSoFar, instance)) {
          listSoFar = [...listSoFar, instance];
        }
      });
      return listSoFar;
    },
  },
});

export const { clearDistributionLists, addDistributionList, updateDistributionList, addDistributionLists } =
  distributionListSlice.actions;

export default distributionListSlice.reducer;
